import { render, staticRenderFns } from "./SubmitItem.vue?vue&type=template&id=1fc1c7c8&scoped=true&"
import script from "./SubmitItem.vue?vue&type=script&lang=js&"
export * from "./SubmitItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1c7c8",
  null
  
)

export default component.exports